import { inject, Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { KeycloakUserModel } from './keycloak-user.model';
import { ReplaySubject, Subject } from 'rxjs';
import { LogService } from 'src/app/shared/log/log.service';

@Injectable({
  providedIn: 'root',
})
export class KeycloakUserService {
  public logoutOngoing$ = new Subject<boolean>()
  private user$ = new ReplaySubject<KeycloakUserModel>(1);

  private readonly keycloak: KeycloakService

  constructor() {
    this.keycloak = inject(KeycloakService);

    this.keycloak.loadUserProfile().then(user => {
      this.user$.next(new KeycloakUserModel(user as ConstructorParameters<typeof KeycloakUserModel>[0]));
      LogService.setUser(user);
    })
  }

  public getUser() {
    return this.user$;
  }

  public logout(redirectUri?: string) {
    this.logoutOngoing$.next(true)
    LogService.resetUser();
    return this.keycloak.logout(redirectUri);
  }
}
